import { render, staticRenderFns } from "./noAccess.vue?vue&type=template&id=13f5e090&scoped=true&"
import script from "./noAccess.vue?vue&type=script&lang=js&"
export * from "./noAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5e090",
  null
  
)

export default component.exports